import Home from "@dashboardViews/Home";
import Sensors from "@dashboardViews/Sensors";
import Users from "@dashboardViews/Users";

export default [
  {
    title: "Tableau de bord",
    icon: "fa-chart-area",
    adminOnly: false,
    route: { path: "/", name: "Home", component: Home },
  },
  {
    title: "Capteurs",
    icon: "fa-microchip",
    adminOnly: false,
    route: { path: "/sensors", name: "Sensors", component: Sensors },
  },
  {
    title: "Utilisateurs",
    icon: "fa-users",
    adminOnly: true,
    route: { path: "/users", name: "Users", component: Users },
  },
];
